import React from "react";
import AudioPlayerRewind from "../../AudioPlayer";
import { useTranslation } from "react-i18next";
import { useAudioEditor } from "../../../../context/AudioEditorContext";
import styles from "./AudioEditorLoader.module.css";

const AudioEditorLoaderPreview = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const { selectedAudio } = useAudioEditor();

    if (!selectedAudio) {
        return <div className={styles.previewEmpty}>{t("noMediaSelected")}</div>;
    }

    const caption = selectedAudio.description?.trim();

    return (
        <div className={styles.previewContainer}>
            <div
                className={[styles.previewCaption, !caption ? styles.previewCaptionMuted : ""]
                    .filter(Boolean)
                    .join(" ")}
            >
                {caption || t("noSoundDescription")}
            </div>
            <div className={styles.previewPlayer}>
                <AudioPlayerRewind
                    src={selectedAudio.url}
                    showAddtoProject={false}
                    hideDownload
                    hideSeparator
                    embedded
                />
            </div>
        </div>
    );
};

export default AudioEditorLoaderPreview;
